// Beslist of een vraag in de open vragenlijst beantwoord is. Gebruikt door de
// verplichte-vraag-controle: staat `Required` aan en is dit false, dan blijft
// de vragenlijst op deze vraag staan.
//
// Matrixvragen horen hier NIET thuis: die vragen om alle rijen, en dat kan
// alleen `matrixRowsComplete` beoordelen — die heeft de rijen uit de database
// nodig, niet alleen de antwoorden.

/**
 * Of één antwoordregel echt een antwoord bevat.
 *
 * `String(...)` vóór het trimmen omdat een antwoord ook een getal kan zijn: een
 * schaalvraag die bij 0 begint levert `Input: 0`. Een falsy-controle (`!input`)
 * zou die respondent tegenhouden op een vraag die hij netjes heeft ingevuld.
 *
 * @param {{Input?: *}} [response] - Regel uit de Responses-context
 * @returns {boolean}
 */
const hasInput = (response) => {
    const input = response?.Input;
    if (input === undefined || input === null) return false;

    return String(input).trim() !== '';
};

/**
 * @param {{Type?: string}} [field] - Het QuestionnaireFields-doc
 * @param {Array<{Input?: *}>} [fieldResponses] - De antwoorden van ALLEEN dit veld
 * @returns {boolean} Of de vraag als beantwoord telt
 */
const isFieldAnswered = (field, fieldResponses) => {
    if (!field) return false;

    return (fieldResponses || []).some(hasInput);
};

export default isFieldAnswered;
